import { setFormatsDataAction as setFormatsDataOperation } from 'editor/src/store/editorModules/formats/slice';

export default setFormatsDataOperation;
